import pharmacy from 'services/pharmacy';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as Types from 'helpers/types';

export default () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const getOrders = async () => {
    try {
      dispatch({type: Types.ORDER_HISTORY_LOADING})
      const response = await pharmacy.get(`/patients/orders`, {
        headers: { 'manual-orders': 'true', 'pharmacy-delivery-orders': 'true', 'api-version' : 'v2' },
      });
      dispatch({type:Types.ORDER_HISTORY_SUCCESS, payload: response.data})
      return response.data;
    } catch (e) {
      dispatch({type:Types.ORDER_HISTORY_ERROR, payload: e})
      history.push('/pharmacy/error');
    }
  };

  return [getOrders];
};
